
import {
  defineComponent, PropType, onMounted, ref, computed,
} from 'vue';
import { useMainStore } from '@/store/mainStore';
import AppBottomPopUp from '@/components/BottomPopUp/AppBottomPopUp.vue';
import DriveSharedBar from '@/modules/drive/components/DriveSharedBar.vue';
import { IFolder, ISharedLable } from '@/types/interfaces';
import { useSpacesStore } from '@/modules/spaces/store/spacesStore';
import DriveService from '@/modules/drive/services/DriveService';
import { contactsToLables, everyoneToLables, groupsToLables } from '@/helpers/labelsFormatter';

export default defineComponent({
  components: {
    AppBottomPopUp,
    // DriveSharedBar,
  },
  props: {
    folder: { type: Object as PropType<IFolder>, required: true },
  },
  emits: ['close'],
  setup(props, { emit }) {
    const mainStore = useMainStore();
    const dataLoading = ref(false);
    const sharedLabels = ref([] as ISharedLable[]);

    const fileAmount = computed(() => props.folder.fileAmount);

    const mediaSize = computed(() => {
      const size = props.folder?.size as number | undefined;
      if (!size) {
        return 'N/A';
      }
      if (size < 1024) {
        return `${size} B`;
      }
      if (size < 1024 * 1024) {
        const sizeInKB = (size / 1024).toFixed(2);
        return `${sizeInKB} KB`;
      }
      const sizeInMB = (size / (1024 * 1024)).toFixed(2);
      return `${sizeInMB} MB`;
    });

    function hidePopUp() {
      emit('close');
    }

    function removeShare(labelId) {
      sharedLabels.value = sharedLabels.value.filter((item) => item.id !== labelId);
    }

    return {
      mainStore,
      sharedLabels,
      hidePopUp,
      removeShare,
      dataLoading,
      mediaSize,
      fileAmount,
    };
  },
});
